import React, { useState } from "react";
import Meta from "../../components/Meta";
import Team from "../../components/about/Team";
// import Features from "../../components/about/Features";
// import CallToAction from "../../components/about/CallToAction";
// import Newsletter from "../../components/about/Newsletter";

const About = () => {
  const [video, setVideo] = useState(false);
  return (
    <>
      <Meta title="About || GMJA Arc-Hive" />

      {/* <!-- Page Title --> */}
      <section className="relative pt-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="container">
          {/* <!-- Page Title Content --> */}
          <div className="mx-auto max-w-2xl py-16 text-center">
            <h1 className="font-display text-jacarta-700 mb-8 text-4xl font-medium dark:text-white">
              About gmja arc-hive
            </h1>
            <p className="dark:text-jacarta-300 text-lg leading-normal">
              A Passion for Preserving Architectural Legacies
            </p>
          </div>
        </div>
      </section>
      {/* <!-- End Page Title --> */}

      {/* <!-- Our Story and Goal --> */}
      <section className="pb-24">
        <div className="container">
          <div className="mx-auto max-w-3xl pt-24">
            <h2 className="font-display text-jacarta-700 mb-6 text-3xl dark:text-white">
              Our Story
            </h2>
            <p className="dark:text-jacarta-300 mb-6">
              {`gmja archive was born out of a shared passion for history,
              culture, and the enduring beauty of architectural heritage. We,
              the founders, were brought together by a deep appreciation for the
              stories embedded in our built environment, and a growing concern
              about the threats posed by time, neglect, and development.`}
            </p>
            <p className="dark:text-jacarta-300 mb-6">
              {`We saw countless architectural gems facing deterioration,
              forgotten narratives fading from memory, and invaluable knowledge
              at risk of being lost forever. Driven by a desire to make a
              difference, we embarked on a mission to document, preserve, and
              share.`}
            </p>
            <h2 className="font-display text-jacarta-700 mb-6 text-3xl dark:text-white">
              Our Goal
            </h2>
            <p className="dark:text-jacarta-300">
              {`Our goal at gmja is simple: to archive and celebrate Ethiopia's
              architectural gems. From ancient churches to modern marvels, we're
              dedicated to showcasing the diverse beauty and rich history of
              Ethiopian architecture. Join us in preserving this cultural
              heritage for future generations. Welcome to GMJA – where
              Ethiopia's architectural legacy shines.`}
            </p>
          </div>
        </div>
      </section>
      {/* <!-- End Our Story and Goal --> */}

      {/* <!-- The Team --> */}
      {/* <Team /> */}
      {/* <!-- End The Team --> */}

      {/* <!-- Features --> */}
      {/* <Features /> */}
      {/* <!-- End Features --> */}

      {/* <!-- Call to Action --> */}
      {/* <CallToAction /> */}
      {/* <!-- End Call to Action --> */}

      {/* <!-- Newsletter Signup --> */}
      {/* <Newsletter /> */}
      {/* <!-- End Newsletter Signup --> */}

      {/* <!-- Video Lightbox --> */}
      {video && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="relative w-full max-w-3xl">
            <button
              className="absolute top-0 right-0 mt-4 mr-4 text-white text-2xl"
              onClick={() => setVideo(false)}
              aria-label="Close video"
            >
              &times;
            </button>
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="gmja arc-hive Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      )}
      {/* <!-- End Video Lightbox --> */}
    </>
  );
};

export default About;
